import { useAuth } from '../../hooks/useAuth'
import { NotificationBell } from '../ui/NotificationBell'

interface Props {
  onMenuToggle?: () => void
}

function ProviderIcon({ provider }: { provider?: string }) {
  if (provider === 'google') {
    return (
      <svg width="14" height="14" viewBox="0 0 24 24" className="shrink-0">
        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
      </svg>
    )
  }
  if (provider === 'azure') {
    return (
      <svg width="14" height="14" viewBox="0 0 23 23" className="shrink-0">
        <path fill="#f25022" d="M1 1h10v10H1z"/>
        <path fill="#00a4ef" d="M1 12h10v10H1z"/>
        <path fill="#7fba00" d="M12 1h10v10H12z"/>
        <path fill="#ffb900" d="M12 12h10v10H12z"/>
      </svg>
    )
  }
  return null
}

export function TopBar({ onMenuToggle }: Props) {
  const { profile, signOut } = useAuth()

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 bg-white border-b border-gray-200 flex items-center justify-between px-4 shadow-sm">
      <div className="flex items-center gap-3">
        {onMenuToggle && (
          <button
            onClick={onMenuToggle}
            className="md:hidden text-gray-500 hover:text-gray-900 text-lg transition-colors"
          >
            &#9776;
          </button>
        )}
        <img src="/redvision-logo-2x.png" alt="Redvision" className="h-7" />
      </div>

      <div className="flex items-center gap-4">
        {profile && (
          <>
            <span className="flex items-center gap-1.5 text-sm text-gray-500 hidden sm:inline-flex">
              <ProviderIcon provider={profile.provider} />
              {profile.email}
            </span>
            <span className="text-xs px-2 py-0.5 rounded-full bg-brand/10 text-brand font-medium uppercase hidden sm:inline">
              {profile.role.replace('_', ' ')}
            </span>
            <NotificationBell orgId={profile.org_id} userId={profile.id} />
          </>
        )}
        <button
          onClick={signOut}
          className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
        >
          Sign out
        </button>
      </div>
    </header>
  )
}
